import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "../src/scss/main.css";
import axios from "axios";
import { handleSessionExpiration } from "./utils";

// Response interceptor - handle expired sessions
axios.interceptors.response.use(
  (response) => {
    // Check for invalid session in successful responses too (some APIs return 200 but with error codes)
    if (response?.data?.responseCode === 401 || response?.data?.responseCode === 403) {
      console.log("Session expired (response code):", response.data.responseCode);
      handleSessionExpiration();
      return Promise.reject(new Error("Session expired"));
    }
    return response;
  },
  (error) => {
    // Handle explicit 401/403 responses (Unauthorized - typically expired tokens)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log("Session expired (HTTP status):", error.response.status);
      handleSessionExpiration();
    }
    return Promise.reject(error);
  }
);

// Request interceptor - check token before making requests
axios.interceptors.request.use(
  (config) => {
    // Skip token check for login-related endpoints
    if (config.url.includes("login") || config.url.includes("forgotPassword")) {
      return config;
    }
    
    // Check if token exists in sessionStorage
    const token = window.sessionStorage.getItem("token");
    if (!token) {
      console.log("No token found for request to:", config.url);
      // Cancel this request and redirect to login
      handleSessionExpiration();
      // Create a cancelled request error
      const error = new Error('Request cancelled due to missing authentication');
      error.isAxiosCancel = true;
      throw error;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <App />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. This comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
